(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.cursor = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getCursorsPosition = getCursorsPosition;
  exports.setCursorsPosition = setCursorsPosition;
  /**
   * get position of input cursor
   */
  function getCursorsPosition(ctrl) {
    /* istanbul ignore if */
    if (!ctrl) {
      return 0;
    }
    var CaretPos = 0; // IE Support
    /* istanbul ignore next */
    if (document.selection) {
      ctrl.focus();
      var Sel = document.selection.createRange();
      Sel.moveStart('character', -ctrl.value.length);
      CaretPos = Sel.text.length;
    } else if (ctrl.selectionStart || ctrl.selectionStart === '0') {
      // Firefox support
      CaretPos = ctrl.selectionStart;
    }
    return CaretPos;
  }

  /**
   * set position of input cursor
   */
  function setCursorsPosition(ctrl, pos) {
    /* istanbul ignore if */
    if (!ctrl) {
      return;
    }
    /* istanbul ignore if */
    // 备注：这里原先有setTimeOut，官方是为了避免某些兼容性问题加入的，但在手机上会引起另外的bug，先删掉。
    if (ctrl.setSelectionRange) {
      // ctrl.focus()
      ctrl.setSelectionRange(pos, pos);
    } else if (ctrl.createTextRange) {
      var range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  }
});